import React, { useEffect } from "react";
import { AclRoutes } from "routes";
import useStores from "stores";

const BlankLayout = ({ route }) => {
  const { loginStore } = useStores();
  // useEffect(() => {
  //   // if (location.pathname === '/app') {
  //   //   history.push('/app/frame');
  //   // }
  // })

  useEffect(() => {
  }, [])

  return <AclRoutes routes={route.routes} authorities={loginStore.authorities} />;
};

export default BlankLayout;
